import axios from 'axios';

/**
 * Fetch custom sidebar items from the API
 * @returns {Promise} Promise with the custom sidebar items data
 */
export const getCustomSidebarItems = async () => {
	try {
		return await axios.get(`/api/customSidebarItems`);
	} catch (error) {
		console.error('Error fetching custom sidebar items:', error);
		return { data: [] };
	}
};

/**
 * Create a new custom sidebar item
 * @param {FormData} formData - Form data with title, link, isExternal and image
 * @returns {Promise} Promise with the created item
 */
export const createCustomSidebarItem = async (formData) => {
	return await axios.post(`/api/customSidebarItems`, formData);
};

/**
 * Update an existing custom sidebar item
 * @param {number} id - The ID of the sidebar item to update
 * @param {FormData} formData - Form data with title, link, isExternal and image
 * @returns {Promise} Promise with the updated item
 */
export const updateCustomSidebarItem = async (id, formData) => {
	return await axios.put(`/api/customSidebarItems/${id}`, formData);
};

/**
 * Delete a custom sidebar item
 * @param {number} id - The ID of the sidebar item to delete
 * @returns {Promise}
 */
export const deleteCustomSidebarItem = async (id) => {
	return await axios.delete(`/api/customSidebarItems/${id}`);
};

/**
 * Reorder custom sidebar items
 * @param {Array<number>} itemIds - Array of item IDs in the desired order
 * @returns {Promise}
 */
export const reorderCustomSidebarItems = async (itemIds) => {
	return await axios.post(`/api/customSidebarItems/reorder`, { itemIds });
};
